import { useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../../api';

/**
 * React Query hook for stations list. Cache is primed from app-init in AuthBootstrap.
 * Use useStations() for the array; use this hook when you need query state (isLoading, refetch, etc.).
 */
export function useStationsQuery() {
  return useQuery({
    queryKey: useStationsQuery.queryKey(),
    queryFn: () => apiClient.stations.fetchAll(),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
}

useStationsQuery.queryKey = () => ['stations'] as const;

export function useStationsRefetch() {
  const client = useQueryClient();

  return () => client.invalidateQueries({ queryKey: useStationsQuery.queryKey() });
}
